'use client'

import type React from 'react'
import { use } from 'react'
import { useModals } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'

import { Dialog, DialogContent } from '@/components/ui'
import { AddToCart } from '@/components/forms/add-to-cart'
import { RefContext, type Refs } from '@/components/providers/ref-provider'

interface AddToCartModalProps extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const AddToCartModal = ({ open }: AddToCartModalProps) => {
  const { closeModal } = useModals()
  const { product } = useAppSelector((state) => state.selectedProduct)
  const { barcodeInputRef } = use(RefContext) as Refs

  return (
    <Dialog
      open={open}
      onOpenChange={() => {
        barcodeInputRef.current?.focus()
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('ADD_TO_CART')}
        size="lg"
        className="min-h-[410px]"
      >
        {product && <AddToCart product={product} />}
      </DialogContent>
    </Dialog>
  )
}
